import { NgFor, NgIf } from '@angular/common';
import { Component } from '@angular/core';
import { Site } from '@curbnturf/entities';
import { SiteFacade } from '@curbnturf/site/src/lib/+state/site.facade';
import { IonicModule, ModalController } from '@ionic/angular';
import { Subscription } from 'rxjs';
import { EnableModalComponent } from './enable-modal/enable-modal.component';

@Component({
  selector: 'curbnturf-enable-confirmation-modal',
  templateUrl: './enable-confirmation-modal.component.html',
  styleUrls: ['./enable-confirmation-modal.component.scss'],
  standalone: true,
  imports: [EnableModalComponent, IonicModule, NgFor, NgIf],
})
export class EnableConfirmationModalComponent {
  sites: Site[];

  modal: HTMLIonModalElement;

  constructor(
    private modalController: ModalController,
    private siteFacade: SiteFacade,
  ) {}

  openModal() {
    const subscriptions: { sitesSubscription?: Subscription } = {};
    subscriptions.sitesSubscription = this.siteFacade.sitesReadyToEnable$.subscribe((sites) => {
      this.sites = sites;

      if (subscriptions?.sitesSubscription) {
        subscriptions.sitesSubscription.unsubscribe();
      }
    });

    this.showModalOnReady();
  }

  publish(): void {
    this.sites.forEach((site) => this.siteFacade.enable(site));
    this.modal.dismiss();
  }

  hide(): void {
    this.sites.forEach((site) => this.siteFacade.enableAndHide(site));
    this.modal.dismiss();
  }

  private showModalOnReady() {
    setTimeout(async () => {
      const results = await this.modalController.getTop();
      if (!results) {
        this.modal = await this.modalController.create({
          component: EnableModalComponent,
          componentProps: {
            sites: this.sites,
            publishFunction: () => this.publish(),
            hideFunction: () => this.hide(),
          },
          cssClass: 'enable-modal center',
        });

        this.modal.present();
      } else {
        this.showModalOnReady();
      }
    }, 3000);
  }
}
